import { useState } from "react";
import { useLocation } from "react-router-dom";

export function WhatsAppButton() {
  const [isHovered, setIsHovered] = useState(false);
  const { pathname } = useLocation();
  if (pathname.startsWith("/dashboard") || pathname.startsWith("/admin")) return null;
  const phoneNumber = "905335487801";
  const message = encodeURIComponent("Merhaba, Corner Gayrimenkul hakkında bilgi almak istiyorum.");
  
  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank", "noopener,noreferrer");
  };

  return (
    <div 
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Tooltip / Açıklama Balonu */}
      <div 
        className={`bg-white dark:bg-zinc-900 text-foreground text-xs font-semibold px-3 py-2 rounded-full shadow-lg border border-border/60 transition-all duration-300 pointer-events-none flex items-center gap-1.5 ${
          isHovered ? "opacity-100 translate-x-0" : "opacity-0 translate-x-2 hidden sm:flex"
        }`}
      >
        <span className="w-2 h-2 rounded-full bg-[#25D366] animate-pulse"></span>
        <span>WhatsApp Danışma Hattı</span>
      </div>

      {/* WhatsApp Butonu */}
      <button
        onClick={handleClick}
        aria-label="WhatsApp ile iletişime geçin (0533 548 78 01)"
        className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20ba59] text-white shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-110 active:scale-95 focus:outline-none focus:ring-4 focus:ring-[#25D366]/40"
      >
        {/* Pulsing ring effect */}
        <span className="absolute -inset-1 rounded-full bg-[#25D366] opacity-30 animate-ping pointer-events-none"></span>

        {/* WhatsApp Official SVG Icon */}
        <svg 
          viewBox="0 0 32 32" 
          className="w-7 h-7 fill-current" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16 2C8.28 2 2 8.28 2 16c0 2.65.74 5.14 2.03 7.27L2.6 29.4l6.32-1.39A13.92 13.92 0 0016 30c7.72 0 14-6.28 14-14S23.72 2 16 2zm8.18 19.82c-.34.97-1.7 1.78-2.77 1.99-.73.14-1.68.25-4.88-1.07-4.09-1.69-6.73-5.83-6.94-6.1-.2-.28-1.66-2.21-1.66-4.21s1.05-2.99 1.42-3.4c.37-.41.82-.51 1.09-.51.27 0 .55 0 .79.01.25.02.59-.1.92.71.34.82 1.16 2.82 1.26 3.03.1.2.17.44.03.71-.14.27-.2.44-.41.68-.2.24-.43.53-.61.71-.2.2-.42.42-.18.83.24.41 1.06 1.75 2.28 2.84 1.57 1.4 2.89 1.83 3.3 2.04.41.2.65.17.89-.1.24-.27 1.02-1.19 1.29-1.6.27-.41.55-.34.92-.2.37.14 2.38 1.12 2.79 1.33.41.2.68.31.78.48.1.17.1 1-.24 1.97z"/>
        </svg>
      </button>
    </div>
  );
}
